module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.5a6aef82.otf";